import React, { Fragment } from 'react'
import styles from './Result.scss'
import cx from 'classnames'
import { WithTooltip } from 'common/styleguide/WithTooltip'
import { Icon } from 'common/Icon'
import { Distance, Elevation } from 'common/units'
import { defineMessages, injectIntl } from 'react-intl'

const messages = defineMessages({
  cuesheet: {
    id: 'Result.cuesheet',
    defaultMessage: 'Cuesheet available'
  }
})

export const Result = ({ img, title, detail, userDetail }) => (
  <div className={styles.Result}>
    <div className={styles.content}>
      <h4 className={styles.resultTitle}>
        {title}
      </h4>
      <div className={styles.resultDetail}>
        {detail}
      </div>
      {userDetail && <div className={cx(styles.resultDetail, styles.userDetail)}>
        {userDetail}
      </div>}
    </div>
    <div className={styles.thumbContainer}>
      {img
        ? <img src={img} className={styles.resultImg} />
        : <div className={styles.noImgBumper} />}
    </div>
  </div>
)

const _Details = ({ distance, elevationGain, shortLocation, countryCode, hasCues, intl }) => {
  const distanceFrag = distance !== null && <Distance value={distance} />
  const eleFrag = elevationGain !== null && <Elevation value={elevationGain} />
  const location = shortLocation && `${shortLocation}, ${countryCode}`

  // Filter out blank or empty entries
  const details = [distanceFrag, eleFrag, location].filter(f => !!f)

  return (
    <Fragment>
      {details.map((d, i) => (
        <Fragment key={i}>
          {d}
          {i + 1 < details.length && ' · '}
        </Fragment>
      ))}
      {hasCues && <WithTooltip><Icon i={'md-document'} title={intl.formatMessage(messages.cuesheet)} className={styles.cuesheetIcon} size={16} /></WithTooltip>}
    </Fragment>
  )
}

export const Details = injectIntl(_Details)

export const UserDetails = ({ id, name }) => (
  <Fragment>
    <a href={`/users/${id}`} target='_blank' onClick={(e) => e.stopPropagation()}>{name}</a>
  </Fragment>
)
